import { FormInputBase } from './form-input-base';

export class CurrencyInput extends FormInputBase<any> {
  override controlType = 'currency';
}
